<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>基本情報</mat-card-title>
    </mat-card-header>
    <form [formGroup]="slideTankatableBasicInfoForm">
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="fill"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] tw-lg:max-w-[full]">
                <mat-label>スライド調整単価名</mat-label>
                <input matInput formControlName="slideadjustmentunitpriceAname" readonly="true"
                    class="font-color-display-only" disabled />
            </mat-form-field>
            <mat-form-field appearance="fill"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] tw-lg:max-w-[full]">
                <mat-label>スライド調整単価説明</mat-label>
                <input matInput formControlName="slideadjustmentunitpriceExplanation" readonly="true"
                    class="font-color-display-only" disabled />
            </mat-form-field>
            <mat-form-field appearance="fill"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                <mat-label>登録単位</mat-label>
                <input matInput formControlName="registrationunit" readonly="true" class="font-color-display-only"
                    disabled style="text-align: right;" />
                <span matSuffix class="tw-ml-[5px] font-color-display-only">ヶ月</span>
            </mat-form-field>
        </div>
        <!-- 会社とエネルギー種別、スライド種別を追加 -->
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="fill"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] tw-lg:max-w-[full]">
                <mat-label>会社</mat-label>
                <input matInput formControlName="companyname" readonly="true" class="font-color-display-only"
                    disabled />
            </mat-form-field>
            <mat-form-field appearance="fill"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                <mat-label>エネルギー種別</mat-label>
                <input matInput formControlName="energyClsname" readonly="true" class="font-color-display-only"
                    disabled />
            </mat-form-field>
            <mat-form-field appearance="fill"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                <mat-label>LP販売形態</mat-label>
                <input matInput formControlName="lpSalfrmAname" readonly="true" class="font-color-display-only"
                    disabled />
            </mat-form-field>
        </div>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="fill"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[90%] tw-lg:max-w-[full]">
                <mat-label>スライド調整単価メモ</mat-label>
                <textarea matInput formControlName="slideadjustmentunitpriceMemo" readonly="true"
                    class="font-color-display-only" disabled>
            </textarea>
            </mat-form-field>
        </div>
    </form>
</mat-card>